// 404 page
import React from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen flex items-center justify-center p-4 bg-gray-50">
      <div className="text-center space-y-8 max-w-md">
        {/* 404 Animation */}
        <div className="relative">
          <h1 className="text-[120px] md:text-[150px] font-bold text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-600 animate-pulse">
            404
          </h1>
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 transform">
            <div className="w-16 h-16 md:w-20 md:h-20">
              <svg 
                viewBox="0 0 24 24" 
                className="w-full h-full fill-current text-gray-300 animate-bounce"
              >
                <path d="M21.71 11.29l-9-9a.996.996 0 00-1.41 0l-9 9a.996.996 0 000 1.41l9 9c.39.39 1.02.39 1.41 0l9-9a.996.996 0 000-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z"/>
              </svg>
            </div>
          </div>
        </div>

        {/* Message */}
        <div className="space-y-4">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-800">
            Page Not Found
          </h2>
          <p className="text-gray-600">
            The page you are looking for doesn't exist or has been moved.
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/admin/dashboard"
            className="px-8 py-3 bg-gradient-to-r from-orange-600 to-red-600 text-white rounded-lg font-medium hover:opacity-90 transition-opacity focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 shadow-lg"
          >
            Go to Admin Dashboard
          </Link>
          <Link
            to="/admin/login"
            className="px-8 py-3 border border-gray-300 text-gray-700 rounded-lg font-medium hover:bg-gray-50 transition-colors focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2"
          >
            Admin Login
          </Link>
        </div>
      </div>
    </div>
  );
}


